export default {
    tabbar: {
        home: 'Ev',
        trading: 'transaction',
        invest: 'Yatırım',
        share: 'paylaş',
        mine: 'Benim.'
    },
    common: {
        deposit: 'depozit',
        withdrawal: 'çizim',
        share: 'paylaş',
        team: 'Takım',
        task: 'Görev',
        addr: 'Adres',
        logout: 'Çıkış',
        wallet: 'CüzdanComment',
        account: 'Hesap',
        promotion: 'Teşvik',
        details: 'Ayrıntılar',
        dailyRevenue: 'Günlük gelir',
        dailyRevenueList: 'Günlük gelir listesi',
        aboutUs: 'Bizim hakkımızda.',
        globalPartners: 'Küresel ortaklar',
        totalBalance: 'Toplam denge',
        profitList: 'Mali gelir listesi',
        notification: 'bildirim',
        previous: 'Önceki',
        close: 'Kapat',
        next: 'Sonraki',
        investWallet: 'Yatırım Cüzdanı',
        financialWallet: 'Mali Cüzdanı',
        recharge: 'Tekrar yükle',
        copySucceeded: 'Başarılı kopyalama',
        copyFailed: 'Değiştirme başarısız oldu',
        promotionWallet: 'Promotion Cüzdanı',
        registerRewardWallet: 'Cüzdanı kaydedin',
        toAddress: 'TRON cüzdanın koleksiyonun adresi (T ile başladı)',
        verifyYourPassword: 'Parolayı doğrula',
        serviceFee: 'Gas fees',
        confirm: 'Teyit et',
        submitted: 'Gönderildi',
        date: 'tarih',
        amount: 'Kıymet',
        accountAvailableBalance: 'Hesap mevcut',
        securityPassword: 'Güvenlik paroli',
        withdrawalPrincipal: 'Müdür tarafından vazgeçme',
        withdrawalProfit: 'Parayı kaldırmak',
        profitRate: 'Faiz oranı',
        notificationAndFAQ: 'SSS ve Bildirimler',
        FAQ: 'SSS',
        FAQs: [
            {
                id: 'q1',
                title: 'Q:Proje özellikleri/giriş',
                content: `R:
1. Sektörün ilk ve kanıtlanmış, denetlenmiş yatırım kanunu olan çözümümüz, akıllı sözleşmelerin yatırımın geleceği olduğunu kanıtlamayı amaçlamaktadır. Uzun ömürlülüğü ve istikrarı, sonuçta kripto endüstrisini ve insanların yatırım ve ticaret hakkındaki düşüncelerini değiştirecek. Geleneksel token endüstrisi, token dolandırıcılıkları, kilimler, piyasa oynaklığı, dürüst olmayan geliştiricilerin kullanıcı fonlarını çalması ve likidite eksikliği gibi birçok zorlukla karşı karşıyadır.

2. Sahip olduğumuz güvenilirlik kodu, çözümün yapısına dayanmaktadır ve çözümümüz, kripto endüstrisinde ortaya çıkan bu ve diğer birçok zorluktan hiçbir şekilde etkilenmeyecektir. Platformumuz piyasa likiditesi gerektirmez. Bu nedenle yatırımınız ve beklenen geliriniz güvende çünkü sektördeki değişikliklere bağımlı değiliz. Bunun yerine, yeni kullanıcı çekiciliğine dayalı ancak akıllı sözleşmelerle çalışan bir çözüm geliştirdik! Kodumuz ve yapımız güvenli olup, uzun ömürlülük ve şeffaflık garantilidir. Bu nedenle, her destekçi/kullanıcı için ayrıntılı ve şeffaf istatistiklere sahip, çok çekici ve sağlam bir yönlendirme programımız var. Oluşturucunun ve diğer kullanıcıların kazançları anında profile eklenir ve diğer DeFi yatırım çözümlerinin aksine insanlar istedikleri zaman anında para çekebilirler.`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q2',
                title: 'Q:Avantajımız nedir?',
                content: `R:Sistemlerimiz Haze güvenlik ekibi tarafından denetlenmektedir ve bağımsız Akıllı Sözleşme denetçilerine sahiptir
1. Güvenli ve güvenilir: para birimi aktarmaya gerek yok, USDT sıfır riskle kendi cüzdanınıza yatırılır
2. Profesyonel istikrar: profesyonel ekip, yıl boyunca istikrarlı çalışma
3. Düşük giriş eşiği: düğüm madenciliği gelirini paylaşın
4.USD ETHW AI Stratejisi-C Madencilik Havuzu: Para transferine gerek yok, istikrarlı gelir
5. Dünyanın en büyük entegre DeFi platformu DEX, IMO ve DAO'yu oluşturmaya kararlıyız`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q3',
                title: 'Q:Nasıl dahil olabilirim?',
                content: `R:
1. Cüzdan zincirdedir ve cüzdan istasyonu bir Dapp tarayıcısıyla donatılmıştır.
2. TRC20'yi USDT'ye bağlayın ve cüzdanınıza yatırın
3. M-cüzdan tarayıcısından Gongwang'a girin
4. Bu projeye katılabilmeniz için cüzdanınızda madencilik ücreti olarak 30 trx'ten fazla olması gerekmektedir.
`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q4',
                title: 'Q:Madenciliğe katılmak ne kadar sürer?',
                content: `R:Zaman hesaplanamaz. Normalde 4 saatte tamamlanabilir. Belirsiz başka sebeplerle karşılaşılması halinde süre uzatılabilir.`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q5',
                title: 'Q:Kârımızı nakde çevirmek için neden madencilik ücreti ödememiz gerekiyor?',
                content: `R:Çünkü madenciliğe katılma sürecinde müşteriler sadece isimleriyle sayılıyor ve oluşan madencilik ücretleri madenciler tarafından ödeniyor. Elde edilen gelir aslında sözleşme havuzundadır ve yalnızca madencilik ücretlerini ödeyerek geliri takas edebilirsiniz.`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q6',
                title: 'Q:Kâr nasıl çekilir?',
                content: `R:USDT aldıktan sonra işlem ücretleri için cüzdanınızda az miktarda TRX bulundurmanız gerekmektedir. Yalnızca bir kez ödeme yapmanız gerekir ve USDT değişimi bir yasal iş günü içinde tamamlanır. Para çekme işlemini başlattığınızda, USDT çekme işlemi otomatik olarak katıldığınız düğümün cüzdan adresine gönderilecektir. Diğer adresler desteklenmez.`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q7',
                title: 'Q:Defi likidite madenciliği nedir?',
                content: `R:Likidite madenciliği bir tür DeFi merkezi olmayan finanstır. Grafik kartı satın almasına, bilgi işlem gücüne katkıda bulunmasına veya pahalı elektrik faturaları ödemesine gerek yok, ancak fon ve likidite sağlayarak gelir elde ediyor. Özellikle son zamanlarda döviz fiyatlarında büyük dalgalanmalar yaşandı. Bazı kararlı coin sahipleri için likidite madenciliği, işlemlere ihtiyaç duymadan gelir elde etmenin ve daha fazla kripto para birimi biriktirmenin bir yoludur.`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q8',
                title: 'Q:O nasıl çalışır?',
                content: `R:Çözümümüz, iki taraf arasındaki sözleşmenin şartlarını otomatik olarak uygulayan bilgisayarlı bir işlem sözleşmesidir. Evrensel sözleşmelere benzer şekilde, platformumuzdaki her iki kullanıcı da işlem yaparken katılım kurallarını ve koşullarını tanımlamalıdır. Bir anlaşmaya varıldığında ve akıllı sözleşme başlatıldığında, önceden belirlenen koşullarda değişiklik yapma şansı sıfır olacak şekilde tasarlandığı gibi çalışır. Bir kullanıcı, bir blockchain düğümünün madencilik havuzunda bir faaliyet başlattığında, sözleşmede kullanılabilir bir bakiye bulunmalıdır. Kullanıcıların geri kalanı, ne zaman satacaklarını veya satın alacaklarını kontrol etmek için artık uzun saatler beklemek zorunda kalmadan, yürütmeyi sözleşmeye bırakıyor. Dolayısıyla sözleşme şartlarına göre yatırımınızın değerinin hiçbir zaman düşmeyeceği garanti edilir; tam tersine kullanıcılarımıza %100 kazanç sağlar.`,
                updatedAt: '2019-07-23 12:00:00'
            }
        ],
        minWithdrawalError: 'Para çekme tutarı tüketilen gas ücretinden fazla olmalıdır',
        supportTips: 'Sayın kullanıcı: Sizin için özel bir madencilik havuzu asistanı hizmeti kurduk. Danışma, şikayet, öneri vb. için bize yazabilirsiniz; 24 saat içinde yanıtlayıp halledeceğiz!',
        tips: 'İpuçları',
        Withdrawals_prohibited: 'Para çekme koşulları şu anda karşılanmıyor, lütfen önce görevi tamamlayın.'
    },
    homePage: {
        theCommonProblem: 'Genelde sorular soruyor.',
        latestAnnouncement: 'Son duyuru',
        block5title: `Tron'a milyoner olarak katılın`,
        block5desc: 'Bütün kullanıcıların en yüksek USDT gelirlerini almasını sağlamak için bulut madenciliğini ve teknolojiyi kullanın.',
        block6title: 'Platform veri gösterisi',
        accumulatedProfit: 'Tahmin edilen gelir',
        membership: 'Üyelik',
        block7title: 'En iyimizde.',
        block7desc: 'hako Singapur\'da kayıtlı bir şirkettir, lisans numarası: PS20200556. TRON Akıllı Zincir (TRON) ağında faaliyet gösteren kripto para birimi alanında denetlenen ve doğrulanan tek akıllı sözleşme yatırım web sitesiyiz. hako bulut madenciliği, Bitcoin USDT ve diğer kripto para birimleri için potansiyel olarak uygun maliyetli bir madencilik hattı sunuyor. Aynı zamanda hem niceliksel ticaret hem de DeFi teknolojisi, az miktarda sermaye ile kolaylıkla blockchain işlemlerine katılmanıza ve sigorta gibi istikrarlı bir gelir elde etmenize olanak tanıyacaktır.',
        tzl: 'Yatırılmış',
        zl: 'Kulaklı'
    },
    investPage: {
        productList: 'Produkt listesi',
        investedList: 'Yatırılmış liste',
        dailyRate: 'Günlük faiz oranı',
        cycle: 'Period',
        day: 'Gün',
        productDetails: 'Ürüntü detayları'
    },
    tradingPage: {
        miningWorking: 'Bulut madencisi çalışıyor.',
        tradingProfit: 'Transaksyon geliri',
        settlementRule: '24 saat araştırma',
        viewAll: 'Hepsini görüntüle',
        quantifyingTransactionRevenue: 'Niteliksel Ticaret Geliri',
        receive: 'Durum',
        received: 'Alındı',
        rule: 'Madencilik kuralları',
        rules: '"Bulut Madenciliği"nin çalışmaya başlamasını ve günlük gelir elde etmenizi istiyorsanız lütfen "Finansal Cüzdan"da aktif hale getirin. Cüzdanınızdaki USDT bakiyesi belirli koşulları karşıladığında günlük gelir elde edersiniz ve elde edilen gelir 30 gün boyunca saklanır. Zamanında talep etmek için lütfen tıklayın. Aşağıdaki tabloya göre günlük gelir yüzdenizi hesaplayın:',
        profit: 'Kâr',
        miningNotWorking: 'Bulut madenciliği çalışmıyor, lütfen etkinleştirin',
        balance: 'denge'
    },
    sharePage: {
        text1: 'Kontaktlarınızı davet edin',
        text2: 'Ya da arkadaşlar ve ödülleri alırlar.',
        text3: 'Ödüllendirin ve ödüllendirin.',
        text4: 'Tavsiye edilen bağlantılarınızı paylaşın ve para kazanmaya başlayın',
        copyLink: 'Bağlantı kopyala'
    },
    minePage: {
        trxDepositInvestment: 'USDT yatırım deposu',
        trxDepositFinancial: 'USDT mali depozit',
        tips: 'Hesabı etkinleştirmek ve çekme fonksiyonunu etkinleştirmek için USDT sayısını taşıyın',
        appServices: 'Uygulama hizmetleri'
    },
    depositPage: {
        text1: 'İki yatırım tarzı var.',
        text2: '1: Yatırım cüzdanına yeniden yüklenirken, farklı döngülere göre gelirleri alabilirsiniz, ve sona erdiğinde başlıca ve gelirleri geri alabilirsiniz.',
        text3: `2:Finansal cüzdanınızda "bulut madenciliği" işlevini etkinleştirin ve her gün Singapur saat dilimine göre (saat 12'den sonra) gelir elde edin`,
        text4: 'notlandırma:',
        text5: 'Yatırım ihtiyaçlarınıza göre, lütfen yatırım hesabı veya zenginlik yönetimi hesabı seçin. Lütfen hesabın yeniden yüklenmesini bekleyin. Bu çok kritik bir sorun.'
    },
    rechargePage: {
        trxAddress: 'TRC20-USDT adresi',
        copyAddress: 'Adresi kopyala',
        tips1: 'Lütfen diğer USDT olmayan malları yeniden yüklemeyin. Yeniden yüklenmeden yaklaşık 5-10 dakika sonra kaydedin.',
        tips2: 'Eğer uzun süredir teslim edilmezse, lütfen bu sayfayı yeniden çekin. En az 5 USDT yatırım.',
        rechargeCompleted: 'Yeniden yükleme tamamlandı',
        inactivated: 'Devre dışı bırakıldı',
        activated: 'Aktif',
        tips3: 'Tekrar tekrar tıklamanıza gerek yok. Bulut madenciliği, istek gönderildikten yaklaşık 5 ila 10 dakika sonra çalışmaya başlar.',
        tips4: 'Uzun süre etkinleştirilmediyse lütfen etkinleştirme düğmesine tekrar tıklayın.',
        ActivateCloudMining: 'Bulut madenciliğini etkinleştirin'
    },
    withdrawalPage: {
        text1: 'Temel hesap dengesi (USDT)',
        text2: 'Çıkarma 24 saat içinde alınacak.',
        dailyWithdrawalLimit: 'Günlük çekilme sınırı',
        unlimit: 'Sınırsız'
    },
    teamPage: {
        intro: 'Doğrudan ve dolaylı olarak davet ettiğiniz kullanıcılar sizin için kâr elde edebilir. A kullanıcısını davet ettiğinizi varsayalım, A kullanıcısının elde ettiği finansal gelir yüzdelik ödül olarak cüzdanınıza gönderilecektir. A kullanıcısı B kullanıcısını davet ederse ve B de C\'yi davet ederse, kullanıcı gelirinin A ({lev2rate}%), B ({lev3rate}%) ve C ({lev4rate}%) yüzdelik ödülünü alabilirsiniz!',
        level: 'Hiyerarşiye',
        lev2: 'lv.2',
        lev3: 'lv.3',
        lev4: 'lv.4',
        quantity: 'Kıymet',
        rewards: 'Geri çekil'
    },
    productDetailsPage: {
        startingAmount: 'Başlangıç miktarı',
        maxInvestmentAmount: 'Maksimum yatırım',
        dailyInterestRate: 'Günlük faiz oranı',
        investableQuantity: 'Yatırılabilir miktarda',
        investmentAmount: 'Yatırım miktarı',
        participateInInvestment: 'Yatırımlara katılmak'
    },
    investedListPage: {
        investmentTime: 'Yatırım zamanı',
        settlementTime: 'Ayarlama zamanı',
        settlementAmount: 'Ayarlama miktarı'
    },
    loginPage: {
        MobileNumber: 'cep telefon numarası',
        LoginPassword: 'Giriş paroli',
        SignIn: 'İçeri gir',
        SignUp: 'Kayıt',
        rememberThePassword: 'Parola hatırla',
        inviteCode: 'Davet kodu',
        captcha: 'Kontrol kodu',
        EncryptedRegistration: 'Şifreleme kayıtları',
        desc: 'Şifreler decentralize bir boru çizgisinde saklanır ve kaybolursa geri alamazlar. Lütfen parolanızı hatırlayın. ',
        registerSuccess: 'Hesap başarıyla yarattı'
    },
    taskPage: {
        desc: 'Kayıtlara davet ettiğiniz her etkili üyelerin yeniden yükleme miktarı belirli bir bölümde çekilme sınırınıza dönüştürülecek.',
        rwconvertRate: 'Dönüştürme ölçeki',
        totalLimit: 'Birleşik sınır',
        availableLimit: 'Mevcut sınır',
        contactService: 'Müşteri hizmeti ile bağlantı kur'
    },
    Please_unlock_your_wallet: 'Lütfen cüzdanınızın kilidini açın',
    Please_open_the_website_in_the_Dapp_browser: 'Lütfen web sitesini Dapp tarayıcısında açın'
}
